var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7143 6.67857H10.9286V1.21429C10.9286 0.543772 10.3528 0 9.64286 0H8.35714C7.64719 0 7.07143 0.543772 7.07143 1.21429V6.67857H1.28571C0.575759 6.67857 0 7.22234 0 7.89286V9.10714C0 9.77766 0.575759 10.3214 1.28571 10.3214H7.07143V15.7857C7.07143 16.4562 7.64719 17 8.35714 17H9.64286C10.3528 17 10.9286 16.4562 10.9286 15.7857V10.3214H16.7143C17.4242 10.3214 18 9.77766 18 9.10714V7.89286C18 7.22234 17.4242 6.67857 16.7143 6.67857Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/PlusIcon.5b0dd30273f043421ba05b1bbe019d50.svg";
export { ForwardRef as ReactComponent };